module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Dados pessoais")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('taxIdNumber')
    }
  }, [_c('label', {
    attrs: {
      "for": "taxIdNumber"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-cpf",
      rawName: "v-mask-cpf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cpf'),
      expression: "'required|cpf'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.taxIdNumberFormatted),
      expression: "taxIdNumberFormatted",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "taxIdNumber",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.taxIdNumberFormatted)
    },
    on: {
      "blur": function($event) {
        return _vm.userExists()
      },
      "change": function($event) {
        _vm.taxIdNumberFormatted = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('taxIdNumber')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('nome')
    }
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('nome')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('birthDate')
    }
  }, [_c('label', {
    attrs: {
      "for": "birthDate"
    }
  }, [_vm._v("Nascimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.birthDateBR),
      expression: "birthDateBR",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10'),
      expression: "'required|min:10'"
    }, {
      name: "mask-birth",
      rawName: "v-mask-birth"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "birthDate"
    },
    domProps: {
      "value": (_vm.birthDateBR)
    },
    on: {
      "change": function($event) {
        _vm.birthDateBR = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('birthDate')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "contact-box"
  }, [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n      " + _vm._s(_vm.errors.first('email')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('celular')
    }
  }, [_c('label', {
    attrs: {
      "for": "celular"
    }
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.cel),
      expression: "cel",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|phone'),
      expression: "'required|phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "celular",
      "name": "celular",
      "title": "celular",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.cel)
    },
    on: {
      "input": _vm.correctCursor2,
      "change": function($event) {
        _vm.cel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block"
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first('celular')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tel),
      expression: "tel",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "telefone",
      "name": "telefone",
      "title": "telefone",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": _vm.correctCursor2,
      "change": function($event) {
        _vm.tel = $event.target.value
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telefone fixo "), _c('span', [_vm._v("(opcional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-38f3837c!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/aggregate-register/user.vue
// module id = 2099
// module chunks = 1